<script>
  import ReviewerImage from '../../../components/ReviewerProfile/ReviewerImage.svelte'
  import Rating from '../../../components/Rating.svelte'
  import Reviewer from '../../../components/ReviewerProfile/Reviewer.svelte'
  import Date from '../../../components/Date.svelte'

  export let reviewerImage
  export let reviewerName
  export let reviewerEmail
  export let nameColor
  export let verifiedBuyerText
  export let verifiedReviewerText
  export let profileBackground
  export let reviewrating
  export let starColor
  export let isVerifiedReviewer
  export let isVerifiedBuyer
  export let date
  export let dateFormat
</script>

<style>
  :global(._2aBvT) {
    position: relative;
    width: 100%;
  }

  :global(._2d_hP) {
    display: flex;
    align-items: center;
  }

  :global(._2_68p) {
    width: 100%;
  }

  :global(._1csFO) {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  :global(._1Wzga) {
    font-size: 12px;
    color: #696c85;
  }
</style>

<div class="_2aBvT">
  <div class="_2d_hP">
    <ReviewerImage
      {reviewerImage}
      {reviewerEmail}
      {reviewerName}
      {profileBackground} />
    <div class="_2_68p">
      <div class="_1csFO">
        <Reviewer
          {reviewerName}
          verifiedText={isVerifiedBuyer ? verifiedBuyerText : verifiedReviewerText}
          {isVerifiedBuyer}
          {isVerifiedReviewer}
          widgetNameColor={nameColor}
          marginLeft="0" />
        <div class="_1Wzga">
          <Date {date} {dateFormat} />
        </div>
      </div>
      <div class="">
        <Rating {reviewrating} {starColor} />
      </div>
    </div>
  </div>
</div>
